export const scrollElementToCenter = (scroller, targetElement) => {
  scroller.scroll({
    behavior: 'smooth',
    left:
      targetElement.offsetLeft -
      scroller.clientWidth / 2 +
      targetElement.clientWidth / 2,
  });
};
